import request from "@/utils/request"

//平台查询sim卡信息
export function Send_QuerySim(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/SendQuerySim",
    method: "get",
    params
  })
}
//设备重启
export function Send_DevRestart(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/SendDevRestart",
    method: "get",
    params
  })
}
//远程对时
export function Send_TimeSync(params) {
  return request({
    url: "/Anno.Plugs.DevRun/SendOrder/TimeSync",
    method: "get",
    params
  })
}
